import React from 'react';
import { IData } from '../interfaces/interfaces';
import { DataNode } from 'antd/es/tree';
import { XPathBlock } from '../components/DocumentProcessing/TreatmentCDA/XPathBlock.tsx/XPathBlock';
import s from '../components/TableAllProjects/TableAllProjects.module.scss';
import {
  initAttributeType,
  initDescriptionNumber,
  initialChildren,
  initialTitle,
  initialXPathLabel,
} from '../TablesSlice';
import { generateUniqueID } from 'web-vitals/dist/modules/lib/generateUniqueID';
import { engReg, rusReg, symbolReg } from '../../../../types/types';
const getUniqueCode = () => {
  return generateUniqueID().replaceAll('-', '_');
};
export const getStatus = (status: number) => {
  switch (status) {
    case 1: {
      return (
        <div className={s.status}>
          <div className={s.successDot} />
          Активный
        </div>
      );
    }
    case 2: {
      return (
        <div className={s.status}>
          <div className={s.plannedDot} />
          Черновик
        </div>
      );
    }
    case 3: {
      return (
        <div className={s.status}>
          <div className={s.processDot} />
          Архив
        </div>
      );
    }
    case 4: {
      return (
        <div className={s.status}>
          <div className={s.errorDot} />
          {status}
        </div>
      );
    }
    default: {
      return (
        <div className={s.status}>
          <div className={s.unknownDot} />
          Черновик
        </div>
      );
    }
  }
};

export const getMappedData = (data, searchValue, attributeTypeOptions) => {
  return data.map((el) => {
    const strTitle = el.title.label as string;
    let children = [];

    if (el.children?.length) {
      children = getMappedData(el.children, searchValue, attributeTypeOptions);
    }
    return {
      ...el,
      title: (
        <XPathBlock
          attributeTypeOptions={attributeTypeOptions}
          blockData={el.title.children}
          searchValue={searchValue}
          strTitle={strTitle}
          id={el.title.key}
        />
      ),
      children,
    };
  });
};

export const getDrawerData = (data) => {
  return data.map((el) => {
    const strTitle = el?.title?.someData.display as string;
    let children = [];

    if (el.children?.length) {
      children = getDrawerData(el.children);
    }
    return {
      ...el,
      key: el?.title?.someData.code,
      title: (
        <div
          style={{
            width: '100%',
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            border: '1px solid #0000000F',
            borderRadius: '6px',
            padding: '4px',
          }}
        >
          {strTitle}
        </div>
      ),
      children,
    };
  });
};

export const loopInfoData = (
  data: IData[],
  key: React.Key,
  callback: (node: IData, i: number, data: IData[]) => void,
) => {
  for (let i = 0; i < data.length; i++) {
    data[i] = { ...data[i] };
    data[i].title = { ...data[i].title };
    if (data[i]?.key === key || data[i]?.title?.children?.englishName === key) {
      return callback(data[i], i, data);
    }
    if (data[i].children) {
      data[i].children = [...data[i].children];
      loopInfoData(data[i].children!, key, callback);
    }
  }
};
export const getIndexSearchText = (text, searched) => {
  return text.toLowerCase().indexOf(searched.toLowerCase());
};
export const getInsensitiveTextSearch = (text, searched) => {
  return text && searched && text.toLowerCase().includes(searched.toLowerCase());
};
export const getCaseInsensitiveTextSearch = (text, searched) => {
  return text && searched && getIndexSearchText(text, searched) > -1;
};
export const loopSearchLabel = (data: IData[], searchValue: string) => {
  const searchedKeys = [];

  const getSearchedKeys = (treData, searchVal) => {
    treData.map((el) => {
      if (
        getCaseInsensitiveTextSearch(el.title.label, searchValue) ||
        getCaseInsensitiveTextSearch(el.title.children?.englishName, searchValue) ||
        getCaseInsensitiveTextSearch(el.title.children?.oidDirectory, searchValue) ||
        getCaseInsensitiveTextSearch(el.title.children?.section, searchValue) ||
        getCaseInsensitiveTextSearch(el.title.children?.description, searchValue)
      ) {
        searchedKeys.push(el.key);
      }
      if (el.children) {
        getSearchedKeys(el.children, searchVal);
      }
    });
  };
  getSearchedKeys(data, searchValue);
  return searchedKeys;
};
export const loopSearchLabelDrawer = (data: IData[], searchValue: string) => {
  const searchedKeys = [];

  const getSearchedKeys = (treData, searchVal) => {
    treData.map((el) => {
      // if (el.title?.props?.children?.indexOf(searchValue) > -1) {
      if (getCaseInsensitiveTextSearch(el.title?.props?.children, searchValue)) {
        searchedKeys.push(el.key);
      }
      if (el.children) {
        getSearchedKeys(el.children, searchVal);
      }
    });
  };

  getSearchedKeys(data, searchValue);
  return searchedKeys;
};
export const loopUniqueEnglishName = (data: IData[], englishName: string, id: string) => {
  const searchedKeys = [];

  const getSearchedKeys = (treData, englishName) => {
    treData.map((el) => {
      if (el.title.children.englishName === englishName && id !== el.key) {
        searchedKeys.push(el.key);
      }
      if (el.children) {
        getSearchedKeys(el.children, englishName);
      }
    });
  };
  getSearchedKeys(data, englishName);
  return searchedKeys;
};

export const getAllKeys = (data: IData[]) => {
  const searchedKeys = [];

  const getSearchedKeys = (treData) => {
    treData.map((el) => {
      searchedKeys.push(el.key);
      if (el.children) {
        getSearchedKeys(el.children);
      }
    });
  };
  getSearchedKeys(data);
  return searchedKeys;
};

export const loop = (
  data: DataNode[],
  key: React.Key,
  callback: (node: DataNode, i: number, data: DataNode[]) => void,
) => {
  for (let i = 0; i < data.length; i++) {
    if (data[i]?.key === key) {
      return callback(data[i], i, data);
    }
    if (data[i].children) {
      loop(data[i].children!, key, callback);
    }
  }
};

export const getPrevKeyNumb = (data) => {
  const prevKey = data.length && data[data.length - 1]?.key;
  const prevKeyArr = prevKey && prevKey.split('-');
  const prevKeyNumb = prevKeyArr && prevKeyArr.at(-1);
  return prevKeyNumb || null;
};

export const getAddedMaxData = (initData, checkedKey) => {
  let data = [...initData];
  let newBlockKey = '';

  if (checkedKey) {
    loopInfoData(data, checkedKey, (node) => {
      const child = [...node.children] || [];
      if (child) {
        const prevKeyNumb = getPrevKeyNumb(child);
        // const key = checkedKey + '-' + ((prevKeyNumb && Number(prevKeyNumb) + 1) || '0');
        const key =
          checkedKey + '_' + ((prevKeyNumb && Number(prevKeyNumb) + 1) || '0') + getUniqueCode();
        newBlockKey = key;
        const newItem = {
          title: {
            key: key,
            label: initialTitle.label,
            children: {
              ...initialChildren,
              englishName: `code_${key}`,
              parentCode: node.title.children.englishName,
              xmlPath: node.title.children.xmlPath || '',
            },
          },
          key,
          children: [],
        };
        node.children = [...child, { ...newItem }];
      }
    });
  } else {
    const prevKeyNumb = getPrevKeyNumb(data);
    // const key = '0' + '-' + ((prevKeyNumb && Number(prevKeyNumb) + 1) || '0');
    const key = '0' + '_' + ((prevKeyNumb && Number(prevKeyNumb) + 1) || '0') + getUniqueCode();
    newBlockKey = key;
    data = [
      ...data,
      {
        title: {
          ...initialTitle,
          key,
          children: {
            ...initialChildren,
            englishName: `code_${key}`,
            parentCode: 'null',
            isParent: false,
          },
        },
        key,
        children: [],
      },
    ];
  }

  return { data: [...data], newBlockKey };
};
//Преобраззование данных структуры в данные для приложения
const getMandatoryPluralityValue = (is_mandatory, is_multiple) => {
  if (is_mandatory === 0 && is_multiple === 0) {
    return '0..1';
  }
  if (is_mandatory === 0 && is_multiple === 1) {
    return '0..*';
  }
  if (is_mandatory === 1 && is_multiple === 0) {
    return '1..1';
  }
  if (is_mandatory === 1 && is_multiple === 1) {
    return '1..*';
  }
  return '1..1';
};
// export const getPreNormalData = (freezeData, isReplace = true, maxData = []) => {
//   let data = [...freezeData];
//   const prevKeyNumb = maxData[maxData.length - 1]?.key;
//   if (!isReplace && prevKeyNumb) {
//     const newNumb = Number(prevKeyNumb.slice(-1)) + 1;
//     const initKey = prevKeyNumb.slice(0, -1) + newNumb;
//     data = data.reduce((acc, el, index) => {
//       if (index === 0) {
//         return [...acc, { ...el, key: initKey }];
//       }
//       // const prev = acc[acc.length - 1]?.key;
//       // const newNumb = prev && Number(prev.slice(-1)) + 1;
//       // const nextKey = prevKeyNumb.slice(0, -1) + newNumb;
//       const nextKey = generateUniqueID();
//       return [...acc, { ...el, key: nextKey }];
//     }, []);
//   }
//   return data;
// };

export const getNormalData = (freezeData) => {
  const data = [...freezeData].sort(
    (a, b) => a.title?.someData?.displ_order - b.title?.someData?.displ_order,
  );
  return data.map((el) => {
    const uniqKey = getUniqueCode();
    const someData = el?.title?.someData || {};
    const {
      code,
      data_type,
      code_type,
      xpath,
      parent_code,
      is_multiple,
      is_mandatory,
      dict_oid,
      section_code,
      description,
      display,
      displ_order,
      ...props
    } = someData;
    const mandatory_plurality = getMandatoryPluralityValue(is_mandatory, is_multiple);
    const titleChildren = {
      englishName: code || '',
      attributeType: data_type || initAttributeType,
      xmlPath: xpath || '',
      parentCode: parent_code || '',
      mandatory_plurality: mandatory_plurality || '',
      oidDirectory: dict_oid || '',
      section: section_code || '',
      description: description || '',
      isParent: code_type === 'group' || false,
      result: '',
      displ_order: displ_order ?? 0,
      ...props,
    };

    const newTitle = {
      key: uniqKey,
      label: el.title.label || display || initialXPathLabel,
      children: { ...titleChildren },
    };
    let children = [];

    if (el.children?.length) {
      const data = [...el.children];
      children = getNormalData(data);
    }
    return {
      ...el,
      key: uniqKey,
      title: newTitle,
      children,
    };
  });
};

export const getUniqueData = (maxData, newData) => {
  const responseData = [...newData];
  const loopUnique = (maxData) => {
    maxData.forEach((el) => {
      const key = el?.title?.children?.englishName;
      loopInfoData(responseData, key, (node, i, parent) => {
        parent.splice(i, 1);
      });
    });
  };
  loopUnique(maxData);
  return responseData;
};
//Преобразование данных структуры в данные для отправки на бэк
const getMandatoryPluralityData = (value) => {
  let is_mandatory: number;
  let is_multiple: number;
  switch (value) {
    case '0..1': {
      is_mandatory = 0;
      is_multiple = 0;
      break;
    }
    case '0..*': {
      is_mandatory = 0;
      is_multiple = 1;
      break;
    }
    case '1..1': {
      is_mandatory = 1;
      is_multiple = 0;
      break;
    }
    case '1..*': {
      is_mandatory = 1;
      is_multiple = 1;
      break;
    }
    default: {
      is_mandatory = 0;
      is_multiple = 0;
    }
  }

  return { is_mandatory, is_multiple };
};
export const getSavedMaxData = (freezeData) => {
  const data = [...freezeData];
  return data.map((el, index) => {
    const childrenSomeData = el?.title?.children || {};
    const {
      englishName,
      attributeType,
      xmlPath,
      parentCode,
      mandatory_plurality,
      oidDirectory,
      section,
      description,
      isParent,
      // key,
      // ...props
    } = childrenSomeData;
    const { is_multiple, is_mandatory } = getMandatoryPluralityData(mandatory_plurality);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const o = {
      title: {
        label: 'Наименование витального параметра_17',
        someData: {
          code: 'sms5_VITAL - code/@next3',
          display: 'Наименование витального параметра_17',
          description: null,
          xpath: '//structuredBody/component/section[code/@code="VITALPARAM"]',
          data_type: null,
          is_multiple: 'false',
          is_mandatory: 'false',
          section_code: 'VITALPARAM',
          dict_oid: null,
          parent_code: 'null',
          code_type: 'field',
        },
      },
      key: '0-3',
      children: [],
    };
    const someData = {
      code: englishName || 'some_name',
      display: el?.title?.label || null,
      description: description || null,
      xpath: xmlPath || null,
      data_type: attributeType.toString() || initAttributeType,
      is_multiple: is_multiple === 1 ? 'true' : 'false',
      is_mandatory: is_mandatory === 1 ? 'true' : 'false',
      section_code: section || null,
      dict_oid: oidDirectory || null,
      parent_code: parentCode || 'null',
      code_type: isParent ? 'group' : 'field',
      displ_order: index,
    };

    const newTitle = {
      label: el?.title?.label || initialXPathLabel,
      someData: { ...someData },
    };
    let children = [];

    if (el.children?.length) {
      const data = [...el.children];
      children = getSavedMaxData(data);
    }
    return {
      ...el,
      title: newTitle,
      children,
    };
  });
};

export const getCheckedKeysMaxData = (maxData, checkedKeys) => {
  if (!checkedKeys.length) {
    return maxData;
  }
  const newData = [];
  const getChecked = (data) => {
    if (data && data.length) {
      for (let i = 0; i < data?.length; i++) {
        const checkedKey = checkedKeys.find((key) => key === data[i].key);
        if (checkedKey) {
          newData.push(data[i]);
        }
        if (data[i]?.children?.length) {
          getChecked(data[i].children);
        }
      }
    }
  };
  getChecked(maxData);
  return newData;
};

//Сохранение измененного блока, переопределение родителя блока
export const saveDataInMaxData = (freezeData, newTitleChildren, title) => {
  let data = [...freezeData];
  const newParents = [];
  loopInfoData(data, newTitleChildren.key, (node, i, parent) => {
    if (node.title.children.parentCode !== newTitleChildren.parentCode) {
      parent.splice(i, 1);
      newParents.push({
        code: newTitleChildren.parentCode,
        newData: newTitleChildren,
        newTitle: title,
        children: [...node.children],
      });
    } else {
      node.title.children = { ...newTitleChildren };
      node.title.label = title;
    }
  });

  if (newParents.length) {
    if (newParents[0].code !== 'null') {
      loopInfoData(data, newParents[0].code, (node) => {
        const child = [...node.children] || [];
        if (child) {
          const prevKeyNumb = getPrevKeyNumb(child);
          const key = node.key + '-' + ((prevKeyNumb && Number(prevKeyNumb) + 1) || '0');
          const newItem = {
            title: {
              key: key,
              label: newParents[0].newTitle,
              children: {
                ...newParents[0].newData,
                key: key,
                englishName: `code_${key}`,
                parentCode: node.title.children.englishName,
              },
            },
            key,
            children: [...newParents[0].children],
          };
          node.children = [...child, { ...newItem }];
        }
      });
    } else {
      const prevKeyNumb = getPrevKeyNumb(data);
      const key = '0' + '-' + ((prevKeyNumb && Number(prevKeyNumb) + 1) || '0');
      data = [
        ...data,
        {
          title: {
            label: newParents[0].newTitle,
            key,
            children: {
              ...newParents[0].newData,
              key,
              englishName: `code_${key}`,
              parentCode: 'null',
            },
          },
          key,
          children: [...newParents[0].children],
        },
      ];
    }
  }
  return data;
};
//Преобразование данных полученных по id проекта в данные для целевой витрины
export const getDataForTargetShowcase = (targetShowcaseData, initDescription = 8) => {
  return targetShowcaseData.map((el) => {
    const { field, src, code, custom_comment } = el;

    const args = el.args ? Object.values(el.args) : [];

    return {
      key: field?.order_number || '-',
      number: field?.order_number || '-',
      englishName: code || '-',
      russianName: field?.display || '-',
      attributeType: field?.data_type || initAttributeType,
      comment: field?.comment || '-',
      xpath: src?.code || '-',
      description: el?.transform_idr || initDescription,
      args: args || [],
      result: 'Результат',
      customComment: custom_comment,
    };
  });
};
//Преобразование данных полученных по парсингу xlsx файла в данные для целевой витрины
export const getXlsxDataForTargetShowcase = (xlsxData, descOptions) => {
  return xlsxData.map((el) => {
    return {
      key: getUniqueCode(),
      number: el.order_number || '-',
      englishName: el.cdamapping_code || '-',
      russianName: el.display || '-',
      attributeType: el.data_type || initAttributeType,
      comment: el.comment || '-',
      xpath: el.cdamapping_code || '-',
      args: el.args || [],
      description: (descOptions || []).find(({ name }) => name === el.cdamapping_code)?.code || '-',
      result: 'Результат',
      customComment: '',
    };
  });
};
//сбор всех кодов блоков родителей
export const getParentDataOptions = (maxData) => {
  const parentCodeOptions = [{ label: ' ', value: 'null' }];
  const getParentCode = (data) => {
    if (data && data.length) {
      for (let i = 0; i <= data?.length; i++) {
        const parentCode = data[i]?.title?.children?.englishName;
        const isParent = data[i]?.title?.children?.isParent;
        if (parentCode && isParent) {
          const hasInArr = parentCodeOptions.find(({ value }) => value === parentCode);
          if (!hasInArr) {
            parentCodeOptions.push({ label: parentCode, value: parentCode });
          }
        }
        if (data[i]?.children?.length) {
          getParentCode(data[i].children);
        }
      }
    }
  };
  getParentCode(maxData);
  return parentCodeOptions;
};
//сбор всех кодов блоков
export const getCodesOptions = (maxData) => {
  const codeOptions = [];
  const getCode = (data) => {
    if (data && data.length) {
      for (let i = 0; i <= data?.length; i++) {
        const code = data[i]?.title?.someData?.code;
        const display = data[i]?.title?.someData?.display;
        if (code) {
          const hasInArr = codeOptions.find(({ value }) => value === code);
          if (!hasInArr) {
            codeOptions.push({ label: display, value: code });
          }
        }
        if (data[i]?.children?.length) {
          getCode(data[i].children);
        }
      }
    }
  };
  getCode(maxData);
  return codeOptions;
};

//ПРОВЕРКА ВСЕХ XPATH одним кликом CDA
export const getDataForCheckXPath = (maxData, fileName) => {
  const reqData = [];
  const getReqData = (data, fileName) => {
    for (let i = 0; i <= data.length; i++) {
      if (data[i]?.title?.children.xmlPath) {
        reqData.push({
          code: data[i]?.title?.children.englishName,
          file_name: fileName,
          xpath: data[i]?.title?.children.xmlPath,
        });
      }

      if (data[i]?.children && data[i]?.children.length) {
        getReqData(data[i].children, fileName);
      }
    }
  };
  getReqData(maxData, fileName);
  return reqData;
};
export const getVerificationXPathData = (xPathResults, maxData) => {
  const data = [...maxData];
  for (let i = 0; i < xPathResults.length; i++) {
    loopInfoData(data, xPathResults[i].code, (node) => {
      node.title.children = { ...node.title.children, result: xPathResults[i].response };
    });
  }
  return data;
};
//ПРОВЕРКА ВСЕХ XPATH одним кликом Target
export const getXPathText = (maxData, elXPath) => {
  let xPathText = '';
  const getParentCode = (data, elXPath) => {
    if (data && data.length) {
      for (let i = 0; i <= data?.length; i++) {
        const englishName = data[i]?.title?.children?.englishName;
        if (englishName === elXPath) {
          xPathText = data[i].title.children.xmlPath;
        }
        if (data[i]?.children?.length) {
          getParentCode(data[i].children, elXPath);
        }
      }
    }
  };
  getParentCode(maxData, elXPath);
  return xPathText;
};
export const getDataForCheckXPathTarget = (targetData, maxData, fileName, key) => {
  const data =
    key && (typeof key === 'string' || typeof key === 'number')
      ? targetData.filter((t) => t.key === key)
      : targetData;

  return data.map((el) => {
    const xPathText = getXPathText(maxData, el.xpath);
    return {
      code: el.xpath,
      file_name: fileName,
      xpath: xPathText,
    };
  });
};
export const getVerificationXPathDataTarget = (xPathResults, targetData) => {
  const data = [...targetData];

  return data.map((el) => {
    const current = xPathResults.find((res) => res.code === el.xpath);
    if (current?.response) {
      return { ...el, result: current.response };
    } else {
      return el;
    }
  });
};

//пример данных которые надо отправить чтоб получить файл xlsx на целевой витрине
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const obj = {
  order_number: 1,
  code: '_effective_from',
  display: 'Дата загрузки в витрину',
  data_type: 'DateTime',
  comment: '',
  cdamapping_code: '',
  cdamapping_name: '',
  transformation_function_code: '',
  transformation_function_name: '',
};
export const getCreateXlsxData = (data, descriptionTargetShowcase, xPathCodes) => {
  return data.map((el) => {
    const descriptionDependent = {
      cdaMappingName: '',
      cdaMappingCode: '',
    };
    if (el.description === initDescriptionNumber) {
      const cdamapping_names = [];
      (el.args || []).forEach((arg) => {
        const cdamapping_name = xPathCodes.find((x) => x.value === arg)?.label || '';
        cdamapping_names.push(cdamapping_name);
      });
      descriptionDependent.cdaMappingName = cdamapping_names.join(', ');
      descriptionDependent.cdaMappingCode = (el.args || []).join(', ');
    } else {
      descriptionDependent.cdaMappingName =
        xPathCodes.find((x) => x.value === el.xpath)?.label || '';
      descriptionDependent.cdaMappingCode = el.xpath;
    }
    return {
      order_number: el.number,
      code: el.englishName,
      display: el.russianName,
      data_type: el.attributeType,
      comment: el.comment,
      cdamapping_code: descriptionDependent.cdaMappingCode,
      cdamapping_name: descriptionDependent.cdaMappingName,
      transformation_function_code: el.description,
      transformation_function_name:
        descriptionTargetShowcase.find(({ id }) => id === el.description)?.name || '',
    };
  });
};

export const getDataFromCDAForTarget = (
  maxData = [],
  maxTargetShowcaseData = [],
  initDescription = 8,
) => {
  const newTargetData = [...maxTargetShowcaseData];
  // const numbList = [];
  // maxTargetShowcaseData.forEach((el) => {
  //   numbList.push(el.number);
  // });
  const getData = (initData) => {
    const data = [...initData].sort(
      (a, b) => a.title?.someData?.displ_order - b.title?.someData?.displ_order,
    );
    if (data && data.length) {
      for (let i = 0; i < data?.length; i++) {
        const {
          code,
          display,
          data_type,
          custom_comment = '',
          code_type,
        } = data[i]?.title?.someData || {};
        const isParent = code_type === 'group';
        const hasInTargetData = !!maxTargetShowcaseData.find((el) => {
          if (el.description === initDescriptionNumber && el.args?.length) {
            return !!(el.args || []).find((arg) => arg === code);
          }
          return el.xpath === code;
        });
        if (!isParent && !hasInTargetData) {
          // const numb = numbList.length + 1;
          const numb = newTargetData.length
            ? newTargetData[newTargetData.length - 1].number + 1
            : 1;

          // numbList.push(numb);
          const row = {
            key: numb ?? '-',
            number: numb ?? '-',
            englishName: code || '-',
            russianName: display || '-',
            attributeType: data_type || initAttributeType,
            comment: '-',
            xpath: code || '-',
            description: initDescription,
            args: [],
            result: 'Результат',
            customComment: custom_comment,
          };
          newTargetData.push(row);
        }
        if (data[i]?.children?.length) {
          getData(data[i].children);
        }
      }
    }
  };
  getData(maxData);

  return newTargetData;
};

export const getDataFromDrop = (data, parentCode = 'null') => {
  return data.map((el) => {
    const props = el.title.props;
    const strTitle = props.strTitle as string;
    const blockData = { ...props.blockData };
    blockData.parentCode = parentCode;
    const key = props.id;
    let children = [];

    if (el.children?.length) {
      const parentCode = blockData.englishName;
      children = getDataFromDrop(el.children, parentCode);
    }
    return {
      ...el,
      title: {
        key: key,
        label: strTitle || initialXPathLabel,
        children: blockData,
      },
      children,
    };
  });
};

const statusStyle = {
  display: 'flex',
  alignItems: 'center',
};

const dotStyle = {
  width: '6px',
  height: '6px',
  borderRadius: '100px',
  marginRight: '8px',
};
const colors = {
  unknownDot: { background: '#9a9898' },
  successDot: { background: '#52C41A' },
  plannedDot: { background: '#FAAD14' },
  errorDot: { background: '#FF4D4F' },
  processDot: { background: '#1890FF' },
};

export const getBlockStatus = (response) => {
  if (Array.isArray(response) && response.length) {
    return (
      <div style={statusStyle}>
        <div style={{ ...dotStyle, ...colors.successDot }} />
      </div>
    );
  } else if (Array.isArray(response) && !response.length) {
    return (
      <div style={statusStyle}>
        <div style={{ ...dotStyle, ...colors.unknownDot }} />
      </div>
    );
  } else if (response === 'error') {
    return (
      <div style={statusStyle}>
        <div style={{ ...dotStyle, ...colors.errorDot }} />
      </div>
    );
  }
  return (
    <div style={statusStyle}>
      <div style={{ ...dotStyle, ...colors.unknownDot }} />
    </div>
  );
};

export const getUrlParams = (currentUrl) => {
  const url = new URL(currentUrl);
  const params = {
    editableTableKey: undefined,
    code: undefined,
  };
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  for (const [name, value] of url.searchParams) {
    // alert(`${name}=${value}`);
    params[name] = value;
  }
  return { params };
};

export const getValidateCase = (fieldValue, loc) => {
  const hasSymbol = fieldValue.match(symbolReg)?.length;
  const hasRus = rusReg.test(fieldValue);
  const hasEng = engReg.test(fieldValue);

  if (loc === 'ru') return hasRus && !hasEng;
  if (loc === 'en') return !hasRus && hasEng && !hasSymbol;
};
